import { forwardRef } from "react";
// eslint-disable-next-line no-restricted-imports
import { type LinkProps, Link as ReactRouterLink } from "react-router-dom";

import { useAppDispatch } from "store";
import { viewStateActions } from "store/slices/view";

// This component is used to navigate to a new page and update the query params in the view state.
export const Link = forwardRef<HTMLAnchorElement, LinkProps>(({ to, onClick, ...props }, ref) => {
  const dispatch = useAppDispatch();

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    let newQueryString = "";

    if (typeof to === "string") {
      newQueryString = new URLSearchParams(to.split("?")[1]).toString();
    } else if (to && typeof to === "object" && "search" in to) {
      newQueryString = new URLSearchParams(to.search).toString();
    }

    // Do not update query params if the link is opened in a new tab
    // (by using command + click on Mac or ctrl + click on Windows)
    if (props.target !== "_blank" && !event.metaKey && !event.ctrlKey && to) {
      dispatch(viewStateActions.updateQueryParams(newQueryString));
    }

    if (onClick) {
      onClick(event);
    }
  };

  return <ReactRouterLink ref={ref} to={to} onClick={handleClick} {...props} />;
});

Link.displayName = "Link";
